"use client";

import { type ReactNode, createContext, useContext, useMemo } from "react";

interface SearchablePageContextValue {
  searchEnabled: boolean;
}

const SearchablePageContext = createContext<SearchablePageContextValue | undefined>(undefined);

export function SearchablePageProvider({
  searchEnabled,
  children,
}: {
  searchEnabled: boolean;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ searchEnabled }), [searchEnabled]);
  return <SearchablePageContext.Provider value={value}>{children}</SearchablePageContext.Provider>;
}

export function useSearchablePage(): boolean {
  const ctx = useContext(SearchablePageContext);
  return ctx?.searchEnabled ?? false;
}
